import React from "react";
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { ERRORSTYLE } from "../util/constants";

export default function AddMember(props) {
  const required = value => (value ? undefined : "Required");

  const checkMember = async (values) => {
    // validate should return an error or undefined
    const member = values["member"];
    const invalid = await props.add(member);
    if (invalid) {
      return { [FORM_ERROR]: invalid };
    } else {
      return undefined;
    }
  };

  return (
    <Form
      onSubmit={checkMember}
      render={({ handleSubmit, submitting, submitError, pristine, form }) => (
        <form
          className="plainform"
          onSubmit={event => {
            handleSubmit(event).then(value => {
              value || form.reset();
            });
          }}
        >
          {props.children}
          <Field name="member" validate={required}>
            {({ input, meta }) => (
              <div>
                <input {...input} type="text" placeholder="userid (e.g. mst3k or mst3k@virginia.edu)" />
                <button type="submit" disabled={pristine || submitting}>
                  Add
                </button>
              </div>
            )}
          </Field>
          {submitError && <div style={ERRORSTYLE}>{submitError}</div>}
        </form>
      )}
    />
  );
}
